import React, { forwardRef } from 'react';
import {
  FDStack, FDPaper, FDCallToActionButton,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import useMobileLayout from 'Hooks/useMobileLayout';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { useBuildCommonFQEventProperties } from 'Views/FreemiumEntry/HasRelationship/Content/Components/utils';

export const ContactForm = forwardRef(({ handleSubmit, showFormFields = true }, ref) => {
  const isMobile = useMobileLayout();
  const {
    resource, saving,
  } = useMetaLayoutContext();
  const { buildCommonFQEventProperties } = useBuildCommonFQEventProperties();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const onFocus = (event, attrName) => {
    logStandardizedEvent(categories.facetQuiz, eventTypes.contactForm, eventSubTypes.fieldFocused, {
      eventProperties: {
        ...buildCommonFQEventProperties(resource),
        fieldName: attrName,
      },
    });
  };

  const onBlur = (evt, attrName) => {
    logStandardizedEvent(categories.facetQuiz, eventTypes.contactForm, eventSubTypes.fieldBlurred, {
      eventProperties: {
        ...buildCommonFQEventProperties(resource),
        fieldName: attrName,
        hasValue: evt?.target?.value?.length > 0,
      },
    });
  };

  return (
    <div ref={ref}>
      <FDStack flex={1} width={'100%'} maxWidth={550} direction={'column'} spacing={2}>
        <FDPaper appearance={'flat'} color={'info'}>
          <FDStack padding={isMobile ? 2 : 4} direction={'column'}>
            <FDStack direction={'column'} spacing={2} wrap>
              <MetaControlField attr={'contactInfoTitle'} />
              <MetaControlField attr={'contactFormDescription'} />
            </FDStack>
            <FDStack direction={'column'} spacing={1} paddingY={2}>
              {showFormFields ? (
                <>
                  <FDStack direction={isMobile ? 'column' : 'row'} spacing={1}>
                    <MetaControlField attr={'firstName'} fullWidth {...dataAttrs('first name input')} onFocus={onFocus} onBlur={onBlur} />
                    <MetaControlField attr={'lastName'} fullWidth {...dataAttrs('last name input')} onFocus={onFocus} onBlur={onBlur} />
                  </FDStack>
                  <MetaControlField attr={'emailAddress'} {...dataAttrs('email input')} onFocus={onFocus} onBlur={onBlur} />
                  <MetaControlField attr={'phoneNumber'} {...dataAttrs('phone number input')} onFocus={onFocus} onBlur={onBlur} />
                  <MetaControlField attr={'householdIncome'} {...dataAttrs('householdIncome input')} onFocus={onFocus} onBlur={onBlur} />

                  <FDStack direction={isMobile ? 'column' : 'row'} spacing={1}>
                    <MetaControlField attr={'estimatedSavings'} {...dataAttrs('estimatedSavings input')} onFocus={onFocus} onBlur={onBlur} />
                    <MetaControlField attr={'age'} {...dataAttrs('age input')} onFocus={onFocus} onBlur={onBlur} />
                  </FDStack>
                  <MetaControlField attr={'residencyConfirmation'} {...dataAttrs('residency confirmation')} />
                </>
              ) : null}
              <FDStack direction={'row'} paddingY={2} justifyContent={'center'}>
                <FDCallToActionButton onClick={handleSubmit} label={resource.attr('primaryActionLabel')} isFullWidth={isMobile} size={'lg'} disabled={saving} {...dataAttrs('get-started-btn')} />
              </FDStack>
            </FDStack>
            <FDStack direction={'column'} spacing={2} wrap>
              <MetaControlField attr={'formDisclosure'} />
              <MetaControlField attr={'generalDisclosure'} />
            </FDStack>
          </FDStack>
        </FDPaper>
      </FDStack>
    </div>
  );
});
